import { EntityEmptyState } from '@pesto/features/src/EntityProfile/components/EntityEmptyState';
import { EntityErrorBanner } from '@pesto/features/src/EntityProfile/components/EntityErrorBanner';
import { LoadingCard } from '@pesto/ui';
import { SmartTable } from '@pesto/ui/features/SmartTable/SmartTable';
import { Smartphone } from 'lucide-react';
import { useNavigate } from 'react-router-dom';

import { useListDevicesQuery } from '../../../../__generated__/graphql/api';
import { routes } from '../../../../constants/routes';
import { useDevicesListConfig } from '../../../Devices/hooks/useDevicesListConfig';
import { toDeviceListItem, type DeviceListItem } from '../../../Devices/toDeviceListItem';

interface UserDevicesTabProps {
  userId: string;
}

export const UserDevicesTab = ({ userId }: UserDevicesTabProps) => {
  const navigate = useNavigate();

  const { data, loading, error } = useListDevicesQuery({
    variables: { userIdSearch: userId },
    notifyOnNetworkStatusChange: true,
  });

  const { getColumns, initialTableState } = useDevicesListConfig([]);

  const rows: DeviceListItem[] = (data?.listDevices?.devices ?? [])
    .filter((d) => d.userId === userId)
    .map(toDeviceListItem);

  const handleRowClicked = (row: DeviceListItem) => {
    if (!row.userId) return;
    navigate(routes.users + '/' + row.userId);
  };

  if (loading && rows.length === 0) {
    return <LoadingCard />;
  }

  if (error) {
    return <EntityErrorBanner message="We couldn't load devices." detail={error.message} />;
  }

  if (rows.length === 0) {
    return <EntityEmptyState icon={Smartphone} title="This customer has no devices on file." />;
  }

  return (
    <SmartTable
      title="Devices"
      rows={rows}
      columns={getColumns(handleRowClicked)}
      loading={loading}
      initialState={initialTableState}
    />
  );
};
